import { coverMap } from "@/pages/cover/js/cover-static";
export const cover = {
  namespaced: true,
  state: {
    // 设计数据
    coverData: JSON.parse(JSON.stringify(coverMap)),
    // 文字样式
    coverTextStyles: [],
    // 背景列表
    coverBackgrounds: [],
    // 元素列表
    coverElements: [],
    // 最终生成的封面列表
    coverDataList: [],
  },
  mutations: {
    // 构造素材和背景的列表
    setCoverElements(state, { elements, backgrounds }) {
      state.coverBackgrounds = backgrounds;
      state.coverElements = elements;
    },
    // 构造文字样式
    setCoverFontStyles(state, textStyles) {
      state.coverTextStyles = textStyles;
    },
    // 更新coverData
    updateCoverData(state, map) {
      if (map.key !== undefined && map.data) {
        if (Array.isArray(map.data)) {
          map.data.splice(map.key, 1, map.value);
        } else {
          map.data[map.key] = map.value;
        }
        return;
      }
      Object.assign(state.coverData, map);
    },
    // 更新coverDataList的数量
    updateCoverDataList(state, map) {
      const { num, isClearCoverDataList, list, index, key, data, value, options } = map;
      if (isClearCoverDataList) state.coverDataList = [];
      // coverDataList中插入num个coverData
      if (num) {
        for (let i = 0; i < num; i++) {
          let cover = JSON.parse(JSON.stringify(state.coverData));
          cover.id = parseInt(Math.random() * 100);
          state.coverDataList.push(cover);
        }
        return;
      }
      // coverDataList插入新值
      if (list && list.length) {
        state.coverDataList.push(...list);
        return;
      }
      // 更新coverDataList的某一项的某个属性
      if (index && key && value) {
        state.coverDataList[index][key] = value;
        return;
      }
      // 更新coverDataList某个属性
      if (data && options) {
        Object.assign(data, options);
        return;
      }
      // 更新coverDataList每一项的某个属性
      state.coverDataList.forEach(cover => {
        if (key !== undefined && data) {
          if (Array.isArray(cover[data])) {
            cover[data].splice(key, 1, value);
          } else {
            cover[data][key] = value;
          }
        } else {
          Object.assign(cover, map);
        }
      });
    },
    // 删除coverDataList的某一项
    deleteCoverData(state, index) {
      state.coverDataList.splice(index, 1);
    },
    // 清除缓存的数据
    clearCoverCacheInfo(state) {
      state.coverTextStyles = [];
      state.coverBackgrounds = [];
      state.coverElements = [];
      state.coverData = JSON.parse(JSON.stringify(coverMap));
      state.coverDataList = [];
    },
  },
};
